import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import "../styles/About.css";
import gsl from "../images/gsl.jpeg";
import jawahar from "../images/jawahar.png";
import krishna from "../images/krishna.png";
import meghana from "../images/meghana.jpg";
import sairam from "../images/sairam.jpg";
import akhila from "../images/akhila.jpg";
import afrin from "../images/afrin.jpeg";


export default function AboutPage() {
  const cvitTeam = [
    { 
      img: jawahar, 
      name: "C.V. Jawahar",
      role: "Professor"
    },
    { 
      img: gsl, 
      name: "Gurupreet Singh Lehal",
      role: "Senior Project Consultant"
    },
    { 
      img: krishna, 
      name: "Krishna Tulsyan",
      role: "Senior Research Engineer"
    }
  ];

  const productLabTeam = [
    {img: akhila, name: "Akhila Sri Manasa Venigalla", role: "Technical Lead" },
    { img: meghana, name: "Meghana Tatavolu", role: "Senior Research Translation Engineer" },
    { img: sairam, name: "Sairam Bonu", role: "Software Development Engineer" },
    { img: afrin, name: "Afrin Syed", role: "Research Engineer" },
  ];

  return (
    <div className="landing-page">
      <Navbar />
      
      <main className="landing-about-page">
        <div className="landing-about-header">
          <h1>About Us</h1>
          <p className="landing-lead-text">
            Centre for Visual Information Technology (CVIT) focuses on basic and advanced research in image processing, computer vision, 
            computer graphics and machine learning.
          </p>
        </div>

        <section className="landing-about-mission">
          <p className="landing-muted">
            This Center deals with the generation, processing, and understanding of primarily visual data. 
            Techniques and tools required to do so efficiently. The activity of this Center overlaps the 
            traditional areas of Computer Vision, Image Processing, Computer Graphics, Pattern Recognition 
            and Machine Learning. CVIT works on both theoretical and practical aspects of visual information 
            processing. The Center aims to keep the right balance between cutting-edge academic research and 
            impactful applied research.
          </p>
        </section>

        <section className="landing-team-section">
          <h2>Team Members</h2>
          <div className="landing-team-grid">
            {cvitTeam.map(member => (
              <div key={member.name} className="landing-team-card">
                <img src={member.img} alt={member.name} className="landing-team-photo" />
                <h3 className="landing-team-name">{member.name}</h3>
                <p className="landing-team-role">{member.role}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="landing-team-section">
          <h2>Product Labs</h2>
          <div className="landing-product-lab-grid">
            {productLabTeam.map((member, idx) => (
              <div key={idx} className="landing-lab-card">
                <img src={member.img} alt={member.name} className="landing-lab-photo" />
                <h4 className="landing-lab-name">{member.name}</h4>
                <p className="landing-muted">{member.role}</p>
              </div>
            ))}
          </div>
        </section>

        <div className="landing-back-link">
          <Link to="/" className="landing-btn landing-btn-ghost">
            ← Back to Home
          </Link>
        </div>
      </main>
    </div>
  );
}